import React from 'react'
import authEffect from "../assets/images/effect-pattern/auth-effect.png";
import usecustomStyles from './customStyles';
import { HeartFilled } from '@ant-design/icons';
import { Col } from 'antd';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { authenticationContent } from '../constants/PageContent/AuthContent';

const customStyles = usecustomStyles();

const ParticleAuth = ({text  , statusHandle}) => {
    let content = authenticationContent?.signUp?.leftPanel;
    const location = useLocation();
    return (
        <React.Fragment>
                <Col style={{ height:"100%" ,backgroundColor: customStyles.colorPrimary, color: customStyles.colorBgContainer, borderRadius: '6px' }}>
                    <div style={{ display: 'flex', flexDirection: "column", alignItems: "space-between", padding: "calc(1.7vw + 10px) calc(1.5vw + 10px)", justifyContent:'space-between', height:'100%' }}>
                        <div style={{ marginBottom: "30px" }}>
                            <img src={authEffect} alt="" style={{ top: "17%", right: "-43px", position: "absolute", zIndex: "1", overflow: "hidden" , opacity:".1"}} />
                        </div>

                        <div className='particle_center'>
                            <h3 className="text_md" style={{ fontWeight: "500" , lineHeight: 1.5 }}>{content?.title}</h3>
                            <p className="sm2" style={{ fontWeight: '400' ,  lineHeight: 1.5}}>{content?.description}</p>
                        </div>

                        <div style={{ marginTop: "50px" }} className="text-center" >
                            <p className='sm'>{text}
                                </p>
                                <div className='text-center'>
                                <Link onClick={()=>{
                                    statusHandle(prev => !prev)
                                }}  className='solid_btn text_white' style={{ marginRight: "5px", textDecoration: "underline", color: customStyles.colorSecondary, fontWeight: "600" , fontSize: '16px' }}>Sign In</Link>
                                </div>
                        </div>
                    </div>
                </Col>
        </React.Fragment>
    )
}

export default ParticleAuth